import { Producer } from "../types";
import { catalogVariantDisplayTextMap } from "./display-text-map.const";

type ConfigItem = {
    producer: Producer,
    variants: Partial<keyof typeof catalogVariantDisplayTextMap>[];
}

export const CATALOG_MODE_CONFIG: ConfigItem[] = [
    {
        producer: Producer.ESSILOR,
        variants: ['magazin', 'prescription']
    },
    {
        producer: Producer.SHAMIR,
        variants: ['ST', 'RX']
    }
]